/* global axios */
import ApiClient from './ApiClient';

class MetaCampaignsAttributionAPI extends ApiClient {
  constructor() {
    super('meta_campaigns_attribution', { accountScoped: true });
  }

  #url(conversationId) {
    return `${this.baseUrl()}/conversations/${conversationId}/meta_campaigns_attribution`;
  }

  getForConversation(conversationId) {
    return axios.get(this.#url(conversationId));
  }

  setForConversation(conversationId, campaignId) {
    return axios.post(this.#url(conversationId), { campaign_id: campaignId });
  }

  removeForConversation(conversationId) {
    return axios.delete(this.#url(conversationId));
  }
}

export default new MetaCampaignsAttributionAPI();
